import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Button, DatePicker, Col, Row, Form, Modal, Select, Input, Upload, Icon, Radio } from 'antd'
import { actions } from '../actions/contractor.actions'
import INNInput from './inn-input';
import { client } from '../actions';
import { authHeader } from '../helpers/auth-header';

const ContractorForm = Form.create()(
	class extends React.Component {

		constructor(props) {
			super(props)

			this.state = {
				fileList: [],
				foundOrgs: [],
				search: "",
				selectedOrg: {},
				searchingOrgsLoading: false,
			}
		}

		searchTimeoutId = null;

		onSearchChange = (search) => {
			clearTimeout(this.searchTimeoutId);
			this.setState({ foundOrgs: [], search, searchingOrgsLoading: true  });
			this.searchTimeoutId = setTimeout(async () => {
				const response = await client.get(`${this.props.searchInnUrl || "/Docs/orgs_by_inn"}/${search}`, {
					headers: authHeader(),
				});
				this.setState({ searchingOrgsLoading: false, foundOrgs: response.data});
			}, 200)
		};

		render() {
			const { visible, onCancel, onCreate, form, fprops } = this.props;

			const { getFieldDecorator, setFieldsValue } = form;

			const options = this.state?.foundOrgs?.map((org, index) => {
				return <Select.Option key={org.inn} value={`${org.inn} ${index}`}>
					{org.inn}
					{org.inn && org.name && " "}
					{org.name}
					{org.name && org.address && " "}
					{org.address && `( ${org.address} )`}
				</Select.Option>
			});

			return (
				<Modal
					width={520}
					visible={visible}
					title="Добавить организацию"
					okText="Добавить"
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
							<Row gutter={16}>
								<Col span={24}>
								<Form.Item
									label="Поиск организации по названию, ИНН"
									validateStatus={this.state.search.length >= 300 ?
										"warning" : ""}
									help={this.state.search.length >= 300 ?
										"Вы достигли максимума в 300 символов" : ""}
								>
										<Select
											showSearch
											placeholder="Введите название организации, ИНН"
											onSearch={(search) => {
												if (search.length && search.length <= 300) {
													this.onSearchChange(search);
												}
											}}
											showArrow={false}
											filterOption={false}
											onChange={(key) => {
												const index = key.split(" ").pop();
												const selectedOrg = this.state.foundOrgs[index];
													this.setState({ selectedOrg });
													setFieldsValue(
														{
															inn: selectedOrg.inn,
															name: selectedOrg.name,
															directorFio: selectedOrg.director
														});
												}}
											defaultActiveFirstOption={false}
											// notFoundContent={null}
											loading={this.state.searchingOrgsLoading}
											notFoundContent={this.state.search &&
												!this.state.searchingOrgsLoading &&
												"Не найдены подходящие компании"}
										>
											{options}
										</Select>
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={16}>
								<Col span={7}>
									<Form.Item label="ИНН">
										{getFieldDecorator('inn', {
											initialValue: '',
											rules: [{ required: false, min: 10, message: 'Пожалуйста укажите ИНН' }]
										})(
											<INNInput />)}
									</Form.Item>
								</Col>
								<Col span={17}>
									<Form.Item label="Наименование">
										{getFieldDecorator('name', {
											initialValue: '',
											rules: [{ required: true, min: 3,  message: 'Пожалуйста укажите наименование организации' }]
										})(
											<Input />
										)}
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="Email">
										{getFieldDecorator('email', {
											initialValue: '',
											rules: [
												{
													type: 'email',
													message: 'Введите корректный email',
												},
												{
													required: true,
													message: 'Укажите email',
												},
											]
										})(
											<Input />
										)}
									</Form.Item>
								</Col>

							</Row>

							<Row gutter={16}>
								<Col span={24}>
									<Form.Item label="ФИО руководителя">
										{getFieldDecorator('directorFio', {
											initialValue: ''
										})(
											<Input />
										)}
									</Form.Item>
								</Col>

							</Row>

						</Form>
				</Modal>
			);
		}
	});


class ContractorRef extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
			formVisible: false,
			formKey: 0,
		}
	}

	handleCancel = () => {
		const form = this.formRef.props.form;
		this.setState({formKey: this.state.formKey + 1})
		form.resetFields();
		this.setState({ formVisible: false })
	}

	handleCreate = () => {
		const form = this.formRef.props.form;
		form.validateFields((err, values) => {
			if (err) return;
			const v = { ...values }
			const saveIdAndCloseModal = (v) => {
				if(this.props.addCreatedOrg) this.props.addCreatedOrg(v);
				form.resetFields();		
				this.setState({ formVisible: false })
				this.setState({formKey: this.state.formKey + 1})
			}
			this.props.reftype=='document' 
				? this.props.dispatch(actions.postDocumentContractor(v, saveIdAndCloseModal))		
				: this.props.dispatch( actions.postContractor(v, saveIdAndCloseModal))
		});
	}

	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	handleCkick = () => {
		this.setState({ formVisible: true })
	}

	render() {
		const { reftype } = this.props
		return <div style={{ ...this.props.style }} >

			<ContractorForm
				key={this.state.formKey}
				wrappedComponentRef={this.saveFormRef}
				visible={this.state.formVisible}
				searchInnUrl={this.props.searchInnUrl}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
			/>

			{reftype == 'document' && 
				<Button type="dashed" 
					onClick={this.handleCkick} style={{borderColor:'#60abf9'}} >
      	<Icon type="plus" style={{color:'#60abf9'}}/><span style={{color:'#60abf9'}}>Создать организацию</span>
				</Button> ||
			<Tooltip title={'Создать организацию'} placement="left">
				<Button  shape="circle" icon="plus" style={{ marginRight: '10px' }}
					onClick={this.handleCkick} />
			</Tooltip>}
		</div>
	}
}

function mapStateToProps(state) {

	const { contractorRefStore } = state;

	return { ...contractorRefStore };
}

export default connect(mapStateToProps)(ContractorRef);